angular.module('sky.templates', []).run(['$templateCache', function($templateCache) {
    $templateCache.put('sky/templates/actionbar/actionbar.html',
        '<div class="bb-action-bar">\n' +
        '    <ng-transclude></ng-transclude>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/actionbar/actionbaritem.html',
        '<button class="btn bb-btn-secondary bb-action-bar-item-button" type="button">\n' +
        '    <ng-transclude></ng-transclude>\n' +
        '</button>\n' +
        '');
    $templateCache.put('sky/templates/actionbar/actionbaritemgroup.html',
        '<div class="bb-action-bar-group">\n' +
        '    <div class="bb-action-bar-buttons hidden-xs">\n' +
        '        <ng-transclude />\n' +
        '    </div>\n' +
        '    <div class="bb-action-bar-dropdown hidden-sm hidden-md hidden-lg">\n' +
        '        <div uib-dropdown>\n' +
        '             <button class="btn bb-btn-secondary dropdown-toggle" type="button" data-toggle="dropdown">\n' +
        '            {{bbActionBarItemGroup.title}}<span class="caret"/>\n' +
        '            </button>\n' +
        '\n' +
        '            <ul uib-dropdown-menu>\n' +
        '\n' +
        '            </ul>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</span>\n' +
        '');
    $templateCache.put('sky/templates/alert/alert.html',
        '<div class="alert" ng-class="[\'alert-\' + (bbAlert.bbAlertType || \'warning\'), bbAlert.bbAlertCloseable === \'true\' ? \'alert-dismissible\' : null]" ng-show="!bbAlert.bbAlertClosed" role="alert">\n' +
        '    <button ng-show="bbAlert.bbAlertCloseable === \'true\'" type="button" class="close" ng-click="bbAlert.close({$event: $event})">\n' +
        '        <span aria-hidden="true">&times;</span>\n' +
        '        <span class="sr-only">{{\'alert_close\' | bbResources}}</span>\n' +
        '    </button>\n' +
        '    <div ng-transclude></div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/avatar/avatar.directive.html',
        '<div class="bb-avatar" ng-switch="bbAvatar.canChange">\n' +
        '  <div ng-switch-when="true">\n' +
        '    <div\n' +
        '       class="bb-avatar-file-drop"\n' +
        '       bb-file-drop\n' +
        '       bb-file-drop-change="bbAvatar.photoDrop(files, rejectedFiles)"\n' +
        '       bb-file-drop-accept="\'image/*\'"\n' +
        '       >\n' +
        '      <ng-include src="\'sky/templates/avatar/avatarinner.include.html\'" onload="bbAvatar.onTemplateLoad()"></ng-include>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '  <div ng-switch-default>\n' +
        '    <ng-include src="\'sky/templates/avatar/avatarinner.include.html\'" onload="bbAvatar.onTemplateLoad()"></ng-include>\n' +
        '  </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/avatar/avatarinner.include.html',
        '<div class="bb-avatar-wrapper">\n' +
        '  <div class="bb-avatar-image" ng-show="bbAvatar.bbAvatarSrc"></div>\n' +
        '  <canvas class="bb-avatar-initials" ng-show="bbAvatar.showInitials()"></canvas>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/card/card.directive.html',
        '<section class="bb-card" ng-class="bbCard.getClass()">\n' +
        '  <header ng-show="bbCard.headingLeftCtrl || bbCard.titleCtrl || bbCard.headingRightCtrl || bbCard.bbCardSelectable">\n' +
        '    <label class="bb-card-header">\n' +
        '      <div class="bb-card-heading-left" ng-if="bbCard.headingLeftCtrl"></div>\n' +
        '      <div class="bb-card-heading-middle">\n' +
        '        <h1 class="bb-card-title" ng-if="bbCard.titleCtrl"></h1>\n' +
        '      </div>\n' +
        '      <div class="bb-card-heading-right" ng-if="bbCard.headingRightCtrl &amp;&amp; !bbCard.bbCardSelectable"></div>\n' +
        '      <div class="bb-card-check" ng-if="bbCard.bbCardSelectable">\n' +
        '        <input type="checkbox" id="{{bbCard.cardCheckId}}" bb-check ng-model="bbCard.bbCardSelected"  />\n' +
        '      </div>\n' +
        '    </label>\n' +
        '  </header>\n' +
        '  <label class="bb-card-content" for="{{bbCard.cardCheckId}}"></label>\n' +
        '  <div class="bb-card-actions" ng-if="bbCard.actionsCtrl"></div>\n' +
        '  <ng-transclude></ng-transclude>\n' +
        '</section>\n' +
        '');
    $templateCache.put('sky/templates/check/labeltext.html',
        '<span class="bb-check-label-text"></span>\n' +
        '');
    $templateCache.put('sky/templates/check/styled.html',
        '<span role="checkbox" tabindex="-1"></span>\n' +
        '');
    $templateCache.put('sky/templates/check/wrapper.html',
        '<label class="bb-check-wrapper"></label>\n' +
        '');
    $templateCache.put('sky/templates/checklist/checklist.directive.html',
        '<div>\n' +
        '  <div>\n' +
        '    <div ng-if="bbChecklist.bbChecklistIncludeSearch" class="bb-checklist-filter-bar">\n' +
        '      <div class="bb-checklist-search" ng-class="{\'bb-search-disabled\': bbChecklist.onlyShowSelected}">\n' +
        '        <input\n' +
        '          type="text"\n' +
        '          class="bb-checklist-search-box"\n' +
        '          maxlength="255"\n' +
        '          placeholder="{{bbChecklist.bbChecklistSearchPlaceholder}}"\n' +
        '          ng-model="bbChecklist.searchText"\n' +
        '          ng-model-options="{debounce: bbChecklist.bbChecklistSearchDebounce}"\n' +
        '          ng-disabled="bbChecklist.onlyShowSelected"\n' +
        '          data-bbauto-field="ChecklistSearch"\n' +
        '          ng-attr-autofocus="{{bbChecklist.focusSearch}}" />\n' +
        '        <div class="bb-checklist-search-icon">\n' +
        '          <i class="fa fa-search"></i>\n' +
        '        </div>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '    <div ng-if="(bbChecklist.bbChecklistCategories &amp;&amp; bbChecklist.bbChecklistCategories.length > 0) || bbChecklist.bbChecklistSubsetLabel" class="bb-checklist-filter-bar bb-checklist-category-bar bb-filters-inline form-inline">\n' +
        '      <div class="form-group" ng-if="bbChecklist.bbChecklistCategories &amp;&amp; bbChecklist.bbChecklistCategories.length > 0">\n' +
        '        <select class="form-control" ng-model="bbChecklist.selectedOption" ng-disabled="bbChecklist.onlyShowSelected">\n' +
        '          <option value="{{bbChecklist.allCategories}}">{{\'grid_column_picker_all_categories\' | bbResources}}</option>\n' +
        '          <option ng-repeat="category in bbChecklist.bbChecklistCategories">{{category}}</option>\n' +
        '        </select>\n' +
        '      </div>\n' +
        '      <div class="form-group">\n' +
        '\n' +
        '        <label class="control-label" ng-if="bbChecklist.bbChecklistSubsetLabel">\n' +
        '          <input class="bb-checklist-subset-input" bb-check type="checkbox" ng-model="bbChecklist.subsetSelected" ng-disabled="bbChecklist.onlyShowSelected"/>\n' +
        '          {{bbChecklist.bbChecklistSubsetLabel}}\n' +
        '        </label>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '    <div class="bb-checklist-filter-bar bb-checklist-select-all-bar" ng-show="!bbChecklist.isSingleSelect()">\n' +
        '      <button type="button" class="btn btn-link" data-bbauto-field="ChecklistSelectAll" ng-click="bbChecklist.selectAll()">{{\'checklist_select_all\' | bbResources}}</button>\n' +
        '      <button type="button" class="btn btn-link bb-checklist-clear" data-bbauto-field="ChecklistClear" ng-click="bbChecklist.clear()">{{\'checklist_clear_all\' | bbResources}}</button>\n' +
        '      <label class="control-label" ng-if="bbChecklist.onlySelectedAvailable">\n' +
        '        <input bb-check type="checkbox" ng-model="bbChecklist.onlyShowSelected" />\n' +
        '        {{\'checklist_only_selected_items\' | bbResources}}\n' +
        '      </label>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '  <div class="bb-checklist-wrapper" bb-wait="bbChecklist.bbChecklistIsLoading" ng-switch="bbChecklist.bbChecklistMode" ng-class="bbChecklist.getChecklistCls()">\n' +
        '    <div ng-switch-when="list" data-bbauto-repeater="ChecklistItems" data-bbauto-repeater-count="{{bbChecklist.filteredItems.length}}">\n' +
        '      <div ng-switch="bbChecklist.isSingleSelect()">\n' +
        '        <div ng-switch-when="true">\n' +
        '          <button ng-repeat="item in bbChecklist.filteredItems" type="button" class="bb-checklist-list-row" ng-class="bbChecklist.getRowCls(item)" data-bbauto-field="{{item.name}}" ng-click="bbChecklist.singleSelectRowClick(item)">\n' +
        '            <ng-include class="bb-checklist-list-col" src="\'sky/templates/checklist/checklistlistrow.include.html\'"></ng-include>\n' +
        '          </button>\n' +
        '        </div>\n' +
        '        <div ng-switch-default>\n' +
        '          <label ng-repeat="item in bbChecklist.filteredItems" class="bb-checklist-list-row" ng-class="bbChecklist.getRowCls(item)" data-bbauto-field="{{item.name}}">\n' +
        '            <div class="bb-checklist-list-col bb-checklist-list-col-checkbox">\n' +
        '              <input bb-check type="checkbox" checklist-model="bbChecklist.bbChecklistSelectedItems" checklist-value="item" checklist-select-style="bbChecklist.bbChecklistSelectStyle" />\n' +
        '            </div>\n' +
        '            <ng-include class="bb-checklist-list-col" src="\'sky/templates/checklist/checklistlistrow.include.html\'"></ng-include>\n' +
        '          </label>\n' +
        '        </div>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '    <table class="table bb-checklist-table" ng-switch-default>\n' +
        '      <thead>\n' +
        '        <tr>\n' +
        '          <th class="bb-checklist-checkbox-column"></th>\n' +
        '          <th ng-repeat="column in bbChecklist.columns" class="{{column.class}}" ng-style="{\'width\': column.width}">{{column.caption}}</th>\n' +
        '        </tr>\n' +
        '      </thead>\n' +
        '      <tbody bb-highlight="bbChecklist.searchText" bb-highlight-beacon="bbChecklist.highlightRefresh" data-bbauto-repeater="ChecklistItems" data-bbauto-repeater-count="{{bbChecklist.filteredItems.length}}">\n' +
        '        <tr ng-repeat="item in bbChecklist.filteredItems" ng-click="bbChecklist.rowClicked(item);" class="bb-checklist-row">\n' +
        '          <td>\n' +
        '            <input ng-click="bbChecklist.inputClicked($event)" bb-check type="checkbox" checklist-model="bbChecklist.bbChecklistSelectedItems" checklist-value="item" data-bbauto-field="{{item[bbChecklist.bbChecklistAutomationField]}}" />\n' +
        '          </td>\n' +
        '          <td ng-repeat="column in bbChecklist.columns" class="{{column.class}}" data-bbauto-field="{{column.automationId}}" data-bbauto-index="{{$parent.$index}}">{{item[column.field]}}</td>\n' +
        '        </tr>\n' +
        '      </tbody>\n' +
        '    </table>\n' +
        '    <div class="bb-checklist-no-items" ng-if="!bbChecklist.filteredItems.length">{{bbChecklist.bbChecklistNoItemsMessage || (\'checklist_no_items\' | bbResources)}}</div>\n' +
        '  </div>\n' +
        '  <div ng-transclude></div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/checklist/checklistlistrow.include.html',
        '<div>\n' +
        '  <div class="bb-checklist-list-title" bb-highlight="bbChecklist.searchText" ng-bind="item.title"></div>\n' +
        '  <div class="bb-checklist-list-description" bb-highlight="bbChecklist.searchText" ng-bind="item.description"></div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/chevron/chevron.directive.html',
        '<button type="button" class="bb-chevron" ng-class="bbChevron.getCls()" ng-click="bbChevron.click($event)" aria-label="{{bbChevron.getLabel()}}">\n' +
        '  <i class="bb-chevron-part bb-chevron-left"></i>\n' +
        '  <i class="bb-chevron-part bb-chevron-right"></i>\n' +
        '</button>\n' +
        '');
    $templateCache.put('sky/templates/contextmenu/contextmenu.html',
        '<div class="bb-context-menu" data-bbauto-field="ContextMenuActions" uib-dropdown>\n' +
        '    <bb-context-menu-button data-bbauto-field="ContextMenuAnchor" ng-click="bbContextMenu.contextButtonStopPropagation($event)" uib-dropdown-toggle></bb-context-menu-button>\n' +
        '    <ul uib-dropdown-menu role="menu">\n' +
        '        <ng-transclude></ng-transclude>\n' +
        '    </ul>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/contextmenu/menubutton.html',
        '<button type="button" class="btn bb-btn-secondary bb-context-menu-btn" aria-label="{{bbContextMenuButton.getAriaLabel()}}">\n' +
        '  <i class="fa fa-ellipsis-h"></i>\n' +
        '</button>\n' +
        '');
    $templateCache.put('sky/templates/contextmenu/menuitem.html',
        '<li role="presentation">\n' +
        '  <a role="menuitem" href="javascript:void(0)" ng-click="bbContextMenuItem.clickItem()">\n' +
        '    <ng-transclude></ng-transclude>\n' +
        '  </a>\n' +
        '</li>\n' +
        '');
    $templateCache.put('sky/templates/contextmenu/submenu.html',
        '<div class="bb-submenu">\n' +
        '    <uib-accordion>\n' +
        '        <uib-accordion-group is-open="bbSubmenu.accordionOpen">\n' +
        '            <uib-accordion-heading ng-if="bbSubmenu.staticHeader">\n' +
        '                <div ng-click="bbSubmenu.toggleAccordion($event)">\n' +
        '                    <span>\n' +
        '                        {{bbSubmenu.heading}}\n' +
        '                    <span>\n' +
        '                    <i ng-class="\'fa-chevron-\' + (bbSubmenu.accordionOpen ? \'up\' : \'down\')" class="fa bb-submenu-chevron"></i>\n' +
        '                </div>\n' +
        '            </uib-accordion-heading>\n' +
        '            <ng-transclude></ng-transclude>\n' +
        '        </uib-accordion-group>\n' +
        '    </uib-accordion>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/contextmenu/submenuheading.html',
        '<uib-accordion-heading>\n' +
        '    <div ng-click="bbSubmenuHeading.toggleAccordion($event)">\n' +
        '        <ng-transclude></ng-transclude>\n' +
        '        <i ng-class="\'fa-chevron-\' + (bbSubmenuHeading.accordionOpen ? \'up\' : \'down\')" class="fa bb-submenu-chevron"></i>\n' +
        '    </div>\n' +
        '</uib-accordion-heading>\n' +
        '');
    $templateCache.put('sky/templates/datefield/datefield.html',
        '<span class="add-on input-group-btn">\n' +
        '    <button type="button" class="btn btn-default bb-date-field-calendar-button">\n' +
        '        <i class="fa fa-calendar"></i>\n' +
        '    </button>\n' +
        '</span>\n' +
        '');
    $templateCache.put('sky/templates/datepicker/datepicker.directive.html',
        '<div>\n' +
        '    <div ng-if="bbDatepicker.loaded" class="input-group bb-datefield">\n' +
        '\n' +
        '        <input name="{{bbDatepicker.inputName}}"\n' +
        '                type="text"\n' +
        '                class="form-control"\n' +
        '                placeholder="{{bbDatepicker.bbPlaceholder}}"\n' +
        '\n' +
        '                ng-model="bbDatepicker.pickerDate"\n' +
        '                ng-model-options="{ allowInvalid: true }"\n' +
        '                ng-keydown="bbDatepicker.enterPress($event)"\n' +
        '\n' +
        '                is-open="bbDatepicker.pickerOpened"\n' +
        '                datepicker-options="bbDatepicker.pickerOptions"\n' +
        '                uib-datepicker-popup="{{bbDatepicker.format}}"\n' +
        '                show-button-bar="bbDatepicker.showButtonBar"\n' +
        '                current-text="{{bbDatepicker.resources.datepicker_today}}"\n' +
        '                clear-text="{{bbDatepicker.resources.datepicker_clear}}"\n' +
        '                close-text="{{bbDatepicker.resources.datepicker_close}}"\n' +
        '                datepicker-append-to-body="{{bbDatepicker.appendToBody}}"\n' +
        '                close-on-date-selection="{{bbDatepicker.closeOnSelection}}"\n' +
        '                alt-input-formats="bbDatepicker.altInputFormats"\n' +
        '\n' +
        '                bb-datepicker-custom-validate="{{bbDatepicker.hasCustomValidation}}"\n' +
        '                bb-datepicker-min-date\n' +
        '                bb-datepicker-max-date\n' +
        '\n' +
        '                 />\n' +
        '        <span class="bb-datepicker-button-container add-on input-group-btn" ng-class="{\'bb-datefield-open\': bbDatepicker.pickerOpened}">\n' +
        '            <button type="button" class="btn btn-default bb-date-field-calendar-button" ng-click="bbDatepicker.open($event)">\n' +
        '                <i class="fa fa-calendar"></i>\n' +
        '            </button>\n' +
        '        </span>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/daterangepicker/daterangepicker.html',
        '<div class="form-inline" ng-form="bbDateRangePickerCtrl.dateRangeForm">\n' +
        '    <div class="form-group bb-date-range-picker-form-group">\n' +
        '      <label class="bb-date-range-picker-label" ng-if="bbDateRangePickerCtrl.pickerLabel && !bbDateRangePickerCtrl.noLabels">{{bbDateRangePickerCtrl.pickerLabel}}</label>\n' +
        '      <select data-bbauto-field="{{bbDateRangePickerCtrl.bbDateRangePickerAutomationId}}_DateRangeType"\n' +
        '        class="form-control"\n' +
        '        ng-options="bbDateRangePickerCtrl.getDateRangeTypeCaption(t) for t in (bbDateRangePickerCtrl.bbDateRangePickerOptions.availableDateRangeTypes || bbDateRangePickerCtrl.defaultDateRangeOptions)"\n' +
        '        ng-model="bbDateRangePickerCtrl.bbDateRangePickerValue.dateRangeType" />\n' +
        '    </div>\n' +
        '    <div class="form-group bb-date-range-picker-form-group" ng-if="bbDateRangePickerCtrl.specificRangeIsVisible">\n' +
        '      <label class="bb-date-range-picker-label" ng-if="!bbDateRangePickerCtrl.noLabels">{{::bbDateRangePickerCtrl.resources.date_range_picker_from_date}}</label>\n' +
        '      <bb-datepicker\n' +
        '        ng-model="bbDateRangePickerCtrl.fromDate"\n' +
        '        bb-datepicker-max="bbDateRangePickerCtrl.maxDate"\n' +
        '        bb-datepicker-name="fromDate"\n' +
        '        bb-datepicker-append-to-body="true"\n' +
        '        bb-datepicker-placeholder="bbDateRangePickerCtrl.fromPlaceholder">\n' +
        '      </bb-datepicker>\n' +
        '      <label class="bb-date-range-picker-date-format-error error" ng-show="bbDateRangePickerCtrl.dateRangeForm.fromDate.$error.dateFormat">{{::bbDateRangePickerCtrl.resources.date_field_invalid_date_message}}</label>\n' +
        '      <label class="bb-date-range-picker-date-max-error error" ng-show="bbDateRangePickerCtrl.dateRangeForm.fromDate.$error.maxDate">{{::bbDateRangePickerCtrl.resources.date_range_picker_max_date_error}}</label>\n' +
        '    </div>\n' +
        '    <div class="form-group bb-date-range-picker-form-group" ng-if="bbDateRangePickerCtrl.specificRangeIsVisible">\n' +
        '      <label class="bb-date-range-picker-label" ng-if="!bbDateRangePickerCtrl.noLabels">{{::bbDateRangePickerCtrl.resources.date_range_picker_to_date}}</label>\n' +
        '      <bb-datepicker\n' +
        '        ng-model="bbDateRangePickerCtrl.toDate"\n' +
        '        bb-datepicker-min="bbDateRangePickerCtrl.minDate"\n' +
        '        bb-datepicker-name="toDate"\n' +
        '        bb-datepicker-append-to-body="true"\n' +
        '        bb-datepicker-placeholder="bbDateRangePickerCtrl.toPlaceholder">\n' +
        '      </bb-datepicker>\n' +
        '      <label class="bb-date-range-picker-date-format-error error" ng-show="bbDateRangePickerCtrl.dateRangeForm.toDate.$error.dateFormat">{{::bbDateRangePickerCtrl.resources.date_field_invalid_date_message}}</label>\n' +
        '      <label class="bb-date-range-picker-date-min-error error" ng-show="bbDateRangePickerCtrl.dateRangeForm.toDate.$error.minDate">{{::bbDateRangePickerCtrl.resources.date_range_picker_min_date_error}}</label>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/error/error.description.directive.html',
        '<div class="bb-error-description-container">\n' +
        '  <span ng-if="bbErrorDescription.description">{{bbErrorDescription.description}}</span>\n' +
        '</div>\n' +
        '<ng-transclude></ng-transclude>\n' +
        '');
    $templateCache.put('sky/templates/error/error.directive.html',
        '<div class="row bb-error">\n' +
        '  <section class="col-xs-12 text-center">\n' +
        '    <div class="bb-error-image" ng-show="bbError.imageCtrl">\n' +
        '      <bb-error-image error-default error-type="{{bbError.imageType}}" ng-if="bbError.imageType !== \'\' && !bbError.imageHasOverride">\n' +
        '      </bb-error-image>\n' +
        '    </div>\n' +
        '    <div class="bb-error-title" ng-show="bbError.titleCtrl">\n' +
        '      <bb-error-title error-default error-type="{{bbError.titleType}}" ng-if="bbError.titleType !== \'\' && !bbError.titleHasOverride">\n' +
        '      </bb-error-title>\n' +
        '    </div>\n' +
        '    <div class="bb-error-description" ng-show="bbError.descriptionCtrl">\n' +
        '      <bb-error-description error-default error-type="{{bbError.descriptionType}}" ng-if="bbError.descriptionType !== \'\' && !bbError.descriptionHasOverride">\n' +
        '      </bb-error-description>\n' +
        '    </div>\n' +
        '    <div class="bb-error-action" ng-show="bbError.actionCtrl"></div>\n' +
        '    <ng-transclude></ng-transclude>\n' +
        '  </section>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/error/error.image.directive.html',
        '<div ng-if="bbErrorImage.bbErrorType" class="bb-error-image-container">\n' +
        '  <div class="bb-error-image-broken" ng-if="bbErrorImage.bbErrorType === \'broken\'">\n' +
        '  </div>\n' +
        '\n' +
        '  <div class="bb-error-image-construction" ng-if="bbErrorImage.bbErrorType === \'construction\'">\n' +
        '  </div>\n' +
        '\n' +
        '  <div class="bb-error-image-notfound" ng-if="bbErrorImage.bbErrorType === \'notFound\'">\n' +
        '  </div>\n' +
        '</div>\n' +
        '<ng-transclude></ng-transclude>\n' +
        '');
    $templateCache.put('sky/templates/error/error.title.directive.html',
        '<div class="bb-error-title-container">\n' +
        '  <span ng-if="bbErrorTitle.title">{{bbErrorTitle.title}}</span>\n' +
        '  <ng-transclude></ng-transclude>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/error/errormodal.template.html',
        '<bb-modal>\n' +
        '  <div class="modal-form">\n' +
        '    <div bb-modal-body>\n' +
        '      <bb-error>\n' +
        '        <bb-error-title>\n' +
        '          {{bbErrorModal.options.errorTitle}}\n' +
        '        </bb-error-title>\n' +
        '        <bb-error-description>\n' +
        '          {{bbErrorModal.options.errorDescription}}\n' +
        '        </bb-error-description>\n' +
        '        <bb-error-action>\n' +
        '          <button type="button" class="btn btn-primary" ng-click="bbErrorModal.close()">{{\'errormodal_ok\' | bbResources}}</button>\n' +
        '        </bb-error-action>\n' +
        '      </bb-error>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '</bb-modal>\n' +
        '');
    $templateCache.put('sky/templates/fileattachments/filedrop.html',
        '<div class="row bb-file-drop-row">\n' +
        '    <div class="col-xs-12 bb-file-drop-col" ng-class="{\'col-sm-6\': bbFileDrop.allowLinks}">\n' +
        '        <div\n' +
        '             class="bb-file-drop bb-file-drop-target"\n' +
        '             ngf-drop\n' +
        '             ngf-keep="false"\n' +
        '             ngf-drag-over-class="{accept: \'bb-file-drop-accept\', reject: \'bb-file-drop-reject\'}"\n' +
        '             ngf-change="bbFileDrop.fileChange($files, $event, $invalidFiles)"\n' +
        '             >\n' +
        '            <div class="bb-file-drop-contents" ng-if="!bbFileDrop.hasTranscludeContents">\n' +
        '                <div class="bb-file-drop-contents-not-over">\n' +
        '                    <h4>{{\'file_upload_drag_file_here\' | bbResources}}</h4>\n' +
        '                    <h5>{{\'file_upload_or_click_to_browse\' | bbResources}}</h5>\n' +
        '                    <i class="fa fa-cloud-upload bb-file-upload-icon"></i>\n' +
        '                </div>\n' +
        '                <div class="bb-file-drop-contents-accept">\n' +
        '                    <h4>{{\'file_upload_drop_files_here\' | bbResources}}</h4>\n' +
        '                    <i class="fa fa-bullseye bb-file-upload-icon"></i>\n' +
        '                </div>\n' +
        '                <div class="bb-file-drop-contents-reject">\n' +
        '                    <h4>{{\'file_upload_invalid_file\' | bbResources}}</h4>\n' +
        '                    <i class="fa fa-times-circle bb-file-upload-icon"></i>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '            <div class="bb-file-drop-contents-custom" ng-transclude></div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="col-sm-6 col-xs-12 bb-file-drop-col" ng-if="bbFileDrop.allowLinks">\n' +
        '        <div class="bb-file-drop-contents">\n' +
        '            <div class="bb-file-drop-link">\n' +
        '                <h4 class="bb-file-drop-link-header">{{\'file_upload_paste_link\' | bbResources}}</h4>\n' +
        '                <div class="form-group">\n' +
        '                    <input\n' +
        '                           type="text"\n' +
        '                           class="form-control"\n' +
        '                           placeholder="{{\'file_upload_link_placeholder\' | bbResources}}"\n' +
        '                           ng-model="bbFileDrop.url"\n' +
        '                           ng-keypress="$event.keyCode === 13 &amp;&amp; bbFileDrop.addLink($event)"\n' +
        '                           />\n' +
        '                </div>\n' +
        '                <button type="button" class="btn btn-primary" ng-disabled="!bbFileDrop.url" ng-click="bbFileDrop.addLink($event)">\n' +
        '                    {{\'file_upload_paste_link_done\' | bbResources}}\n' +
        '                </button>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/fileattachments/fileitem.html',
        '<div class="bb-file-item">\n' +
        '    <div class="row bb-file-item-title">\n' +
        '        <div class="col-xs-10">\n' +
        '            <div class="bb-file-item-name">\n' +
        '                <strong>{{item.name || item.url}}</strong>\n' +
        '            </div>\n' +
        '            <div class="bb-file-item-size" ng-if="bbFileItem.isFile()">\n' +
        '                ({{item.size | bbFileSize}})\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="col-xs-2">\n' +
        '            <div class="pull-right">\n' +
        '                <button type="button" class="btn bb-btn-secondary bb-file-item-btn-delete" ng-click="itemDelete()">\n' +
        '                    <i class="glyphicon glyphicon-trash"></i>\n' +
        '                </button>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '    <div class="row">\n' +
        '        <div ng-switch="bbFileItem.isImg()" class="col-xs-3">\n' +
        '            <div ng-switch-when="true" class="center-block">\n' +
        '              <img ng-if="item.url" class="bb-file-item-preview-img" ng-src="{{item.url}}" />\n' +
        '              <img ng-if="!item.url" class="bb-file-item-preview-img" ngf-src="item" />\n' +
        '            </div>\n' +
        '            <div ng-switch-when="false" class="bb-file-item-preview-other">\n' +
        '                <i class="fa" ng-class="bbFileItem.otherCls"></i>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div class="col-xs-9" ng-transclude>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/actionbar.html',
        '<div ng-show="locals.showActionBar" data-bbauto-view="GridActionBar">\n' +
        '    <div ng-if="!locals.showMobileActions" class="bb-grid-action-bar">\n' +
        '        <div ng-if="!locals.mobileButtons" class="bb-grid-action-bar-buttons" ng-repeat="action in locals.actions">\n' +
        '            <button type="button" class="btn" ng-class="{\'btn-primary\': action.isPrimary, \'bb-btn-secondary\': !action.isPrimary}" data-bbauto-field="{{action.automationId}}" ng-click="action.actionCallback()" ng-disabled="action.selections.length < 1">{{action.title}} ({{action.selections.length}})</button>\n' +
        '        </div>\n' +
        '        <div ng-if="locals.mobileButtons" class="bb-grid-action-bar-buttons">\n' +
        '            <button type="button" class="btn btn-primary" ng-click="locals.chooseAction()">\n' +
        '                <span>{{resources.grid_action_bar_choose_action}}</span>\n' +
        '            </button>\n' +
        '        </div>\n' +
        '        <button type="button" class="btn bb-grid-action-bar-clear-selection" ng-click="locals.clearSelection()">\n' +
        '            {{resources.grid_action_bar_clear_selection}}\n' +
        '        </button>\n' +
        '    </div>\n' +
        '    <div ng-if="locals.showMobileActions" class="bb-grid-action-bar-mobile-buttons">\n' +
        '        <div class="bb-grid-action-bar-btn-container">\n' +
        '            <div ng-repeat="action in locals.actions">\n' +
        '                <button type="button" class="bb-grid-action-bar-mobile-btn btn btn-block btn-lg" ng-class="{\'btn-primary\': action.isPrimary, \'bb-btn-secondary\': !action.isPrimary}" ng-click="action.actionCallback()" ng-disabled="action.selections.length < 1">{{action.title}} ({{action.selections.length}})</button>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <button type="button" class="btn bb-grid-action-bar-mobile-cancel bb-grid-action-bar-clear-selection" ng-click="locals.cancelChooseAction()">\n' +
        '            {{resources.grid_action_bar_cancel_mobile_actions}}\n' +
        '        </button>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/columnpicker.html',
        '<bb-modal data-bbauto-view="ColumnPicker">\n' +
        '  <bb-modal-header bb-modal-help-key="$parent.columnPickerHelpKey">{{\'grid_column_picker_header\' | bbResources}}</bb-modal-header>\n' +
        '  <div bb-modal-body>\n' +
        '    <bb-checklist\n' +
        '                  bb-checklist-items="columns"\n' +
        '                  bb-checklist-selected-items="locals.selectedColumns"\n' +
        '                  bb-checklist-include-search="\'true\'"\n' +
        '                  bb-checklist-search-placeholder="{{\'grid_column_picker_search_placeholder\' | bbResources}}"\n' +
        '                  bb-checklist-no-items-message="{{\'grid_column_picker_search_no_columns\' | bbResources}}"\n' +
        '                  bb-checklist-categories="categories"\n' +
        '                  bb-checklist-mode="list"\n' +
        '                  bb-checklist-filter-local\n' +
        '                  bb-checklist-subset-label="locals.subsetLabel"\n' +
        '                  bb-checklist-subset-property="{{locals.subsetProperty}}"\n' +
        '                  ng-attr-bb-checklist-subset-exclude="{{locals.subsetExclude}}"\n' +
        '                  ng-attr-bb-checklist-only-selected="{{locals.onlySelected}}"\n' +
        '                  >\n' +
        '    </bb-checklist>\n' +
        '  </div>\n' +
        '  <bb-modal-footer>\n' +
        '    <bb-modal-footer-button-primary data-bbauto-field="ColumnPickerSubmit" ng-click="applyChanges()">{{\'grid_column_picker_submit\' | bbResources}}</bb-modal-footer-button-primary>\n' +
        '    <bb-modal-footer-button-cancel data-bbauto-field="ColumnPickerCancel"></bb-modal-footer-button-cancel>\n' +
        '  </bb-modal-footer>\n' +
        '</bb-modal>\n' +
        '');
    $templateCache.put('sky/templates/grids/dropdown.html',
        '<div class="bb-context-menu" data-bbauto-field="ContextMenuActions" uib-dropdown dropdown-append-to-body ng-if="locals.items.length > 0" is-open="locals.is_open">\n' +
        '    <bb-context-menu-button data-bbauto-field="ContextMenuAnchor" ng-click="locals.toggleDropdown($event)">\n' +
        '    </bb-context-menu-button>\n' +
        '    <ul uib-dropdown-menu role="menu">\n' +
        '        <bb-context-menu-item ng-repeat="item in locals.items" bb-context-menu-action="item.cmd()">{{item.title}}</bb-context-menu-item>\n' +
        '    </ul>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/filters.html',
        '<div style="display:none;">\n' +
        '    <div bb-scrolling-view-keeper="viewKeeperOptions" class="bb-grid-filters grid-filters">\n' +
        '        <div class="bb-grid-filters-box" bb-scroll-into-view="locals.expanded">\n' +
        '            <div class="bb-grid-filters-icon" ng-click="locals.expanded = !locals.expanded"></div>\n' +
        '            <div class="bb-grid-filters-container" style="display:none;">\n' +
        '                <div class="bb-grid-filters-header" ng-click="locals.expanded = !locals.expanded">\n' +
        '                    <h4 class="bb-grid-filters-header-title">{{resources.grid_filters_header}}</h4>\n' +
        '                    <span class="bb-grid-filters-header-hide">{{resources.grid_filters_hide}}</span>\n' +
        '                </div>\n' +
        '                <div class="bb-grid-filters-body" ng-transclude></div>\n' +
        '                <div class="bb-grid-filters-footer">\n' +
        '                    <button data-bbauto-field="ApplyGridFilters" class="btn btn-primary" type="submit" ng-click="applyFilters()">{{resources.grid_filters_apply}}</button>\n' +
        '                    <button data-bbauto-field="ClearGridFilters" class="btn bb-btn-secondary" type="button" ng-click="clearFilters()">{{resources.grid_filters_clear}}</button>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/filtersgroup.html',
        '<div class="form-group" ng-class="isCollapsed ? \'collapsed\' : \'collapsible\'">\n' +
        '    <div ng-click="isCollapsed = !isCollapsed">\n' +
        '        <i ng-class="\'glyphicon-chevron-\' + (isCollapsed ? \'down\' : \'up\')" class="bb-grid-filters-body-group-header-icon glyphicon"></i>\n' +
        '        <label>{{bbGridFiltersGroupLabel}}</label>\n' +
        '    </div>\n' +
        '    <div class="bb-grid-filters-body-group-content" uib-collapse="!!isCollapsed" ng-transclude></div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/filterssummary.html',
        '<div class="toolbar bb-table-toolbar bb-applied-filter-bar">\n' +
        '    <div class="bb-applied-filter-header">\n' +
        '        <span>{{resources.grid_filters_summary_header}}</span>\n' +
        '    </div>\n' +
        '    <div class="bb-applied-filter-content-container">\n' +
        '      <div tabindex="0" role="button" class="bb-applied-filter-content" ng-click="openFilterMenu()">\n' +
        '          <span class="bb-applied-filter-text" data-bbauto-field="FilterSummaryText" ng-transclude></span>\n' +
        '          <span tabindex="0" role="button" class="fa fa-times close" data-bbauto-field="FilterSummaryRemove" ng-click="clearFilters(); $event.stopPropagation();"></span>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/grid.html',
        '<section class="bb-grid-container" data-bbauto-grid="{{options.automationId}}" data-bbauto-timestamp="{{locals.timestamp}}" data-bbauto-repeater="{{options.automationId}}" data-bbauto-repeater-count="{{locals.rowcount}}">\n' +
        '\n' +
        '\n' +
        '    <div class="bb-grid-toolbar-viewkeeper">\n' +
        '        <div ng-if="!customToolbar.hasCustomToolbar">\n' +
        '            <div ng-show="locals.showToolbar">\n' +
        '                <bb-grid-toolbar>\n' +
        '                    <ng-transclude></ng-transclude>\n' +
        '                </bb-grid-toolbar>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '\n' +
        '        <div ng-if="customToolbar.hasCustomToolbar">\n' +
        '            <div ng-show="locals.showToolbar">\n' +
        '                <ng-transclude></ng-transclude>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '\n' +
        '    <div class="clearfix"></div>\n' +
        '\n' +
        '    <div class="table-responsive" bb-wait="options.loading">\n' +
        '        <table id="{{locals.gridId}}" class="bb-grid-table" ng-class="{\'grid-multiselect\' : locals.multiselect}"></table>\n' +
        '        <div class="bb-grid-empty-wait" ng-if="locals.hasWaitAndEmpty()"></div>\n' +
        '    </div>\n' +
        '\n' +
        '    <div ng-if="!paginationOptions" class="bb-table-loadmore" data-bbauto-field="LoadMoreButton" ng-show="options.hasMoreRows" ng-click="locals.loadMore()">\n' +
        '        <span class="fa fa-cloud-download"></span>\n' +
        '        <button type="button" class="btn btn-link">{{resources.grid_load_more}}</button>\n' +
        '    </div>\n' +
        '\n' +
        '    <div ng-if="paginationOptions" class="bb-grid-pagination-container">\n' +
        '        <uib-pagination ng-show="paginationOptions.recordCount > options.data.length" total-items="paginationOptions.recordCount" items-per-page="paginationOptions.itemsPerPage" ng-model="paginationOptions.currentPage" ng-change="paginationOptions.pageChanged()" max-size="paginationOptions.maxPages"></uib-pagination>\n' +
        '        <div class="clearfix"></div>\n' +
        '    </div>\n' +
        '\n' +
        '    <div class="bb-grid-action-bar-and-back-to-top">\n' +
        '        <bb-grid-action-bar ng-if="locals.multiselect && multiselectActions && updateMultiselectActions" bb-multiselect-actions="multiselectActions" bb-selections-updated="updateMultiselectActions(selections)">\n' +
        '        </bb-grid-action-bar>\n' +
        '        <div class="bb-table-backtotop" data-bbauto-field="BackToTopButton" ng-show="locals.isScrolled" ng-click="locals.backToTop();">\n' +
        '            <span style="float:left">\n' +
        '                <span class="fa fa-arrow-up "></span>\n' +
        '                <button type="button" class="btn btn-link">{{resources.grid_back_to_top}}</button>\n' +
        '            </span>\n' +
        '            <span style="float:right">\n' +
        '                <span class="fa fa-arrow-up "></span>\n' +
        '                <button type="button" class="btn btn-link">{{resources.grid_back_to_top}}</button>\n' +
        '            </span>\n' +
        '            <div class="clearfix"></div>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</section>\n' +
        '');
    $templateCache.put('sky/templates/grids/gridtoolbar.html',
        '<div class="bb-grid-toolbar-container">\n' +
        '    <div class="clearfix toolbar bb-table-toolbar">\n' +
        '        <button type="button" data-bbauto-field="AddButton" class="bb-grid-toolbar-btn btn-primary btn" ng-show="toolbarLocals.hasAdd" ng-click="options.onAddClick()">\n' +
        '            <i class="fa fa-plus-circle"></i>\n' +
        '            <span class="bb-toolbar-btn-label" ng-show="options.onAddClickLabel">{{options.onAddClickLabel}}</span>\n' +
        '        </button>\n' +
        '        <div class="bb-grid-toolbar-button-container">\n' +
        '            <ng-transclude></ng-transclude>\n' +
        '        </div>\n' +
        '        <div class="bb-search-container search-container">\n' +
        '            <input type="text" placeholder="{{resources.grid_search_placeholder}}" ng-model="searchText" ng-keyup="$event.keyCode == 13 && toolbarLocals.applySearchText()" data-bbauto-field="SearchBox" />\n' +
        '            <div class="bb-search-icon fa fa-search" data-bbauto-field="SearchButton" ng-click="toolbarLocals.applySearchText()"></div>\n' +
        '        </div>\n' +
        '        <button type="button" class="btn bb-btn-secondary bb-grid-toolbar-btn bb-column-picker-btn" data-bbauto-field="ColumnPickerButton" ng-show="!options.hideColPicker" ng-click="toolbarLocals.openColumnPicker()">\n' +
        '            <span class="fa fa-columns"></span>\n' +
        '            <span class="bb-toolbar-btn-label">{{resources.grid_columns_button}}</span>\n' +
        '        </button>\n' +
        '        <button type="button" class="btn bb-btn-secondary bb-grid-toolbar-btn bb-filter-btn" ng-class="{\'bb-filters-inline-active\': options.filtersAreActive}" data-bbauto-field="FilterButton" ng-show="!options.hideFilters" ng-click="toolbarLocals.toggleFilterMenu()">\n' +
        '            <span class="fa fa-filter"></span>\n' +
        '            <span class="bb-toolbar-btn-label">{{resources.grid_filters_button}}</span>\n' +
        '        </button>\n' +
        '    </div>\n' +
        '    <div class="bb-grid-filter-summary-container">\n' +
        '    </div>\n' +
        '    <div class="bb-grid-filter-inline-container" ng-hide="options.hasInlineFilters && !toolbarLocals.filtersVisible">\n' +
        '    </div>\n' +
        '    <div class="bb-grid-top-scrollbar">\n' +
        '        <div></div>\n' +
        '    </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/grids/seemore.html',
        '<div bb-text-expand="data" bb-text-expand-max-length="100" style="white-space: pre-wrap"></div>\n' +
        '');
    $templateCache.put('sky/templates/modal/modal.html',
        '<div class="bb-modal-content-wrapper" ng-transclude></div>');
    $templateCache.put('sky/templates/modal/modalfooter.html',
        '<div class="modal-footer" ng-transclude></div>\n' +
        '');
    $templateCache.put('sky/templates/modal/modalfooterbutton.html',
        '<button class="btn bb-btn-secondary" type="button" ng-transclude></button>\n' +
        '');
    $templateCache.put('sky/templates/modal/modalfooterbuttoncancel.html',
        '<button class="btn btn-link" type="button" ng-click="$parent.$parent.$dismiss(\'cancel\');" ng-transclude></button>');
    $templateCache.put('sky/templates/modal/modalfooterbuttonprimary.html',
        '<button class="btn btn-primary" type="submit" ng-transclude></button>');
    $templateCache.put('sky/templates/modal/modalheader.html',
        '<div class="modal-header">\n' +
        '    <h1 class="bb-dialog-header" ng-transclude></h1>\n' +
        '    <div class="fa fa-times close" ng-click="$parent.$parent.$dismiss(\'close\');"></div>\n' +
        '    <div bb-help-button bb-help-key="{{bbModalHelpKey}}" bb-set-help-key-override="true" data-bbauto-field="ModalHelpButton" ng-if="bbModalHelpKey"></div>\n' +
        '    <div class="clearfix"></div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/navbar/navbar.html',
        '<nav class="navbar navbar-default bb-navbar" ng-transclude></nav>');
    $templateCache.put('sky/templates/page/page.html',
        '<section ng-if="locals.noPageStatusSpecified() || bbPageStatus === locals.pageStatuses.LOADED">\n' +
        '    <div ng-transclude ng-init="locals.onShowing()"></div>\n' +
        '</section>\n' +
        '<section class="container-fluid bb-page-content-column-container" ng-show="bbPageStatus === locals.pageStatuses.NOT_AUTHORIZED">\n' +
        '    <div class="row">\n' +
        '        <section class="bb-page-content-column col-xs-12 text-center">\n' +
        '            <div class="m">\n' +
        '                <h3>\n' +
        '                    {{resources.page_noaccess_header}}\n' +
        '                </h3>\n' +
        '            </div>\n' +
        '            <div class="bb-page-noaccess-description">{{resources.page_noaccess_description}}</div>\n' +
        '            <div class="m-lg">\n' +
        '                <button type="button" class="btn btn-lg btn-primary" ng-click="locals.navigateAway()" data-bbauto-field="NavigateAwayButton">\n' +
        '                    {{resources.page_noaccess_button}}\n' +
        '                </button>\n' +
        '            </div>\n' +
        '        </section>\n' +
        '    </div>\n' +
        '</section>\n' +
        '');
    $templateCache.put('sky/templates/pagesummary/pagesummary.directive.html',
        '<div class="bb-page-header">\n' +
        '  <div class="container-fluid">\n' +
        '    <div class="bb-page-summary-alert"></div>\n' +
        '    <div class="row">\n' +
        '      <div class="bb-page-summary-left col-xs-12" ng-class="bbPageSummary.getPageSummaryLeftCls()">\n' +
        '        <div class="bb-page-summary-image" ng-show="bbPageSummary.imageCtrl"></div>\n' +
        '        <div>\n' +
        '          <h1 class="bb-page-summary-title" ng-show="bbPageSummary.titleCtrl"></h1>\n' +
        '          <h2 class="bb-page-summary-subtitle" ng-show="bbPageSummary.subtitleCtrl"></h2>\n' +
        '          <div class="bb-page-summary-status" ng-show="bbPageSummary.statusCtrl"></div>\n' +
        '          <div class="bb-page-summary-key-info-xs"></div>\n' +
        '          <div class="bb-page-summary-content"></div>\n' +
        '        </div>\n' +
        '      </div>\n' +
        '      <div class="bb-page-summary-key-info-sm col-sm-3 hidden-xs" ng-class="bbPageSummary.getKeyInfoCls()">\n' +
        '        <div class="bb-page-summary-key-info"></div>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '  <ng-transclude></ng-transclude>\n' +
        '</div>\n' +
        '<div class="bb-page-summary-action-bar"></div>\n' +
        '');
    $templateCache.put('sky/templates/popover/popup.html',
        '<div class="popover"\n' +
        '    tooltip-animation-class="fade"\n' +
        '    uib-tooltip-classes\n' +
        '    ng-class="{ in: isOpen() }">\n' +
        '  <div class="arrow"></div>\n' +
        '\n' +
        '  <div class="popover-inner">\n' +
        '    <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n' +
        '    <div class="popover-content"\n' +
        '        uib-tooltip-template-transclude="contentExp()"\n' +
        '        tooltip-template-transclude-scope="originScope()"></div>\n' +
        '  </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/reorder/reorder.directive.html',
        '<div class="bb-reorder-container">\n' +
        ' <div ng-repeat="item in bbReorder.bbReorderItems" class="bb-reorder-list-row">\n' +
        '   <div class="bb-reorder-list-row-container">\n' +
        '     <div class="bb-reorder-list-col bb-reorder-list-col-icon">\n' +
        '       <i class="fa fa-arrows"></i>\n' +
        '     </div>\n' +
        '     <div class="bb-reorder-list-col bb-reorder-list-col-content">\n' +
        '       <div class="bb-reorder-list-title">{{item.title}}</div>\n' +
        '       <div class="bb-reorder-list-description">{{item.description}}</div>\n' +
        '     </div>\n' +
        '     <button type="button" ng-show="!$first &amp;&amp; !bbReorder.sorting" ng-click="bbReorder.pushToTop(item)" class="bb-reorder-list-col bb-reorder-list-col-top btn btn-link">\n' +
        '       <i class="fa fa-arrow-circle-up"></i>\n' +
        '       <span>{{\'reorder_top\' | bbResources}}</span>\n' +
        '     </button>\n' +
        '     <div ng-show="bbReorder.sorting" class="bb-reorder-list-col">\n' +
        '       <span class="bb-reorder-list-sorting-number"></span>\n' +
        '     </div>\n' +
        '   </div>\n' +
        ' </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/repeater/repeater.directive.html',
        '<div class="bb-repeater-component bb-repeater">\n' +
        '  <ng-transclude></ng-transclude>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/repeater/repeater.item.directive.html',
        '<section class="bb-repeater-item" ng-class="bbRepeaterItem.getCls()">\n' +
        '  <div class="bb-repeater-item-left">\n' +
        '    <div class="bb-repeater-item-context-menu" ng-if="bbRepeaterItem.contextMenuCtrl"></div>\n' +
        '  </div>\n' +
        '  <div class="bb-repeater-item-right">\n' +
        '    <header class="bb-repeater-item-header" ng-click="bbRepeaterItem.headerClick()">\n' +
        '      <h1 class="bb-repeater-item-title" ng-if="bbRepeaterItem.titleCtrl"></h1>\n' +
        '      <bb-chevron bb-chevron-direction="bbRepeaterItem.chevronDirection"></bb-chevron>\n' +
        '    </header>\n' +
        '    <div class="bb-repeater-item-content">\n' +
        '      <ng-transclude></ng-transclude>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '</section>\n' +
        '');
    $templateCache.put('sky/templates/selectfield/selectfield.directive.html',
        '<ng-include src="bbSelectField.getFieldInclude()"></ng-include>\n' +
        '<div ng-transclude></div>\n' +
        '');
    $templateCache.put('sky/templates/selectfield/selectfieldmultiple.include.html',
        '<button type="button" class="btn btn-link bb-select-field-multiple" ng-click="bbSelectField.selectFieldClick()">\n' +
        '  <i class="fa fa-plus-circle"></i> <span class="bb-select-field-multiple-title">{{bbSelectField.bbSelectFieldText}}</span>\n' +
        '</button>\n' +
        '<div>\n' +
        '  <ul class="list-unstyled bb-select-field-multiple-items">\n' +
        '    <li class="bb-select-field-multiple-item" ng-if="bbSelectField.bbSelectFieldSelectedItems.length <= 5" ng-repeat="selectedItem in bbSelectField.bbSelectFieldSelectedItems">\n' +
        '      <div class="bb-select-field-multiple-item-title">\n' +
        '        {{selectedItem.title}}\n' +
        '      </div>\n' +
        '      <button class="close bb-select-field-multiple-item-delete" ng-click="bbSelectField.remove(selectedItem); bbSelectField.setModelTouched()">\n' +
        '        <span aria-hidden="true">&times;</span>\n' +
        '        <span class="sr-only">{{\'selectfield_remove\' | bbResources}}</span>\n' +
        '      </button>\n' +
        '    </li>\n' +
        '    <li class="bb-select-field-multiple-item" ng-if="bbSelectField.bbSelectFieldSelectedItems.length > 5">\n' +
        '      <div class="bb-select-field-multiple-item-title bb-select-field-multiple-summary">\n' +
        '        {{bbSelectField.getSummaryCountText()}}\n' +
        '      </div>\n' +
        '      <button class="close bb-select-field-multiple-item-delete" ng-click="bbSelectField.removeAll(); bbSelectField.setModelTouched()">\n' +
        '        <span aria-hidden="true">&times;</span>\n' +
        '        <span class="sr-only">{{\'selectfield_remove\' | bbResources}}</span>\n' +
        '      </button>\n' +
        '    </li>\n' +
        '  </ul>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/selectfield/selectfieldpicker.directive.html',
        '<bb-modal>\n' +
        '  <div class="modal-form">\n' +
        '    <bb-modal-header>{{bbSelectFieldPicker.getDialogHeaderText()}}</bb-modal-header>\n' +
        '    <div bb-modal-body>\n' +
        '      <ng-include src="bbSelectFieldPicker.bbSelectFieldPickerTemplate"></ng-include>\n' +
        '    </div>\n' +
        '  </div>\n' +
        '  <bb-modal-footer ng-if="!bbSelectFieldPicker.isSingleStyle()">\n' +
        '    <bb-modal-footer-button-primary ng-click="bbSelectFieldPicker.okClick()">\n' +
        '      {{\'selectfieldpicker_select\' | bbResources}}\n' +
        '    </bb-modal-footer-button-primary>\n' +
        '    <bb-modal-footer-button-cancel></bb-modal-footer-button-cancel>\n' +
        '  </bb-modal-footer>\n' +
        '  <bb-modal-footer ng-if="bbSelectFieldPicker.isSingleStyle()">\n' +
        '    <bb-modal-footer-button ng-click="bbSelectFieldPicker.clearClick()">\n' +
        '      {{\'selectfieldpicker_clear\' | bbResources}}\n' +
        '    </bb-modal-footer-button>\n' +
        '  </bb-modal-footer>\n' +
        '</bb-modal>\n' +
        '');
    $templateCache.put('sky/templates/selectfield/selectfieldsingle.include.html',
        '<button type="button" class="btn btn-default bb-select-field-single" ng-click="bbSelectField.selectFieldClick()">\n' +
        '  <div class="bb-select-field-single-inner">\n' +
        '    <div class="bb-select-field-single-title">{{bbSelectField.bbSelectFieldSelectedItems[0].title}}<span class="bb-select-field-single-title-placeholder" ng-if="!bbSelectField.bbSelectFieldSelectedItems[0].title">{{bbSelectField.bbSelectFieldText}}</span></div>\n' +
        '    <div class="bb-select-field-single-icon"><i class="fa fa-sort"></i></div>\n' +
        '  </div>\n' +
        '</button>\n' +
        '');
    $templateCache.put('sky/templates/tabs/tab.html',
        '<div ng-hide="!tabsInitialized" data-bbauto-field="{{bbTabAutomationId}}" class="responsiveTabControl">\n' +
        '    <ul ng-transclude>\n' +
        '\n' +
        '    </ul>\n' +
        '</div>');
    $templateCache.put('sky/templates/tabset/addbutton.html',
        '<button ng-click="bbTabAdd()" type="button" class="bb-tab-button-wrap btn bb-tab-button-add bb-btn-secondary">\n' +
        '  <span class="btn bb-btn-secondary"><i class="fa fa-lg fa-plus-circle"></i></span>\n' +
        '</button>\n' +
        '');
    $templateCache.put('sky/templates/tabset/dropdown.html',
        '<div class="bb-tabset-dropdown nav nav-tabs" uib-dropdown ng-show="bbTabsetOptions.isSmallScreen &amp;&amp; bbTabsetOptions.tabCount > 1">\n' +
        '  <button type="button" class="btn btn-primary bb-tab-dropdown-button" uib-dropdown-toggle><div class="bb-tab-header-text">{{bbTabsetOptions.selectedTabHeader}}</div><i class="fa fa-caret-down"></i></button>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/tabset/largeheading.html',
        '<div class="hidden-xs"></div>\n' +
        '');
    $templateCache.put('sky/templates/tabset/openbutton.html',
        '<button ng-click="bbTabOpen()" type="button" class="bb-tab-button-wrap bb-tab-button-open btn bb-btn-secondary">\n' +
        '  <span class="btn bb-btn-secondary"><i class="fa fa-lg fa-folder-open-o"></i></span>\n' +
        '</button>\n' +
        '');
    $templateCache.put('sky/templates/tabset/smallheading.html',
        '<div class="visible-xs">{{bbTabHeadingXs}}</div>\n' +
        '');
    $templateCache.put('sky/templates/tabset/tabbutton.html',
        '<li class="bb-tab-button"></li>\n' +
        '');
    $templateCache.put('sky/templates/textexpand/container.html',
        '<div class="bb-text-expand-container"></div>\n' +
        '');
    $templateCache.put('sky/templates/textexpand/ellipsis.html',
        '<span class="bb-text-expand-ellipsis">...</span>\n' +
        '');
    $templateCache.put('sky/templates/textexpand/expandmodal.html',
        '<bb-modal>\n' +
        '  <bb-modal-header>\n' +
        '    {{expandCtrl.headerContent}}\n' +
        '  </bb-modal-header>\n' +
        '  <div class="modal-form">\n' +
        '    <div bb-modal-body>\n' +
        '      <div>\n' +
        '        <span class="bb-text-expand-text">{{expandCtrl.textExpandContent}}</span>\n' +
        '      </div>\n' +
        '    </div>\n' +
        '    <bb-modal-footer>\n' +
        '      <bb-modal-footer-button-cancel>{{::expandCtrl.closeText}}</bb-modal-footer-button-cancel>\n' +
        '    </bb-modal-footer>\n' +
        '  </div>\n' +
        '</bb-modal>\n' +
        '');
    $templateCache.put('sky/templates/textexpand/seemore.html',
        '<button type="button" class="btn bb-btn-link-inline bb-text-expand-see-more"></button>\n' +
        '');
    $templateCache.put('sky/templates/textexpand/space.html',
        '<span class="bb-text-expand-space"> </span>\n' +
        '');
    $templateCache.put('sky/templates/textexpand/text.html',
        '<span class="bb-text-expand-text"></span>\n' +
        '');
    $templateCache.put('sky/templates/tiles/tile.html',
        '<section ng-class="{ \'collapsed\': bbTile.isCollapsed }" class="bb-tile">\n' +
        '    <div bb-scroll-into-view="bbTile.scrollIntoView">\n' +
        '        <div class="bb-tile-title" ng-click="bbTile.titleClick()">\n' +
        '            <div class="bb-tile-header-with-content">\n' +
        '                <h2 class="bb-tile-header">{{bbTile.tileHeader}}</h2>\n' +
        '            </div>\n' +
        '            <div class="bb-tile-header-column-tools">\n' +
        '                <div class="bb-tile-tools">\n' +
        '                    <button type="button" ng-class="\'fa-chevron-\' + (bbTile.isCollapsed ? \'down\' : \'up\')" class="fa bb-tile-chevron"></button>\n' +
        '                    <button type="button" ng-if="bbTile.hasSettings" class="bb-tile-settings bb-icon bb-icon-config" ng-click="$event.stopPropagation();bbTile.bbTileSettingsClick();"></button>\n' +
        '                    <i class="bb-tile-grab-handle glyphicon glyphicon-th" ng-click="$event.stopPropagation()"></i>\n' +
        '                </div>\n' +
        '            </div>\n' +
        '        </div>\n' +
        '        <div uib-collapse="bbTile.isCollapsed" class="bb-tile-content in collapse" ng-transclude>\n' +
        '        </div>\n' +
        '    </div>\n' +
        '</section>\n' +
        '');
    $templateCache.put('sky/templates/tiles/tiledashboard.html',
        '<div class="row">\n' +
        '  <div class="col-md-6 bb-page-content-tile-column bb-page-content-tile-column-sortable" data-dashboard-column="1">\n' +
        '    <div ng-repeat="tile in bbTileDashboard.tiles" data-tile-id="{{tile.id}}" data-ui-view="{{tile.view_name}}" id="{{tile.view_name}}">\n' +
        '    </div>\n' +
        '  </div>\n' +
        '\n' +
        '  <div class="col-md-6 bb-page-content-tile-column bb-page-content-tile-column-sortable" data-dashboard-column="2">\n' +
        '  </div>\n' +
        '</div>\n' +
        '');
    $templateCache.put('sky/templates/tiles/tileheadercheck.html',
        '<i class="fa fa-check bb-tile-header-check"></i>');
    $templateCache.put('sky/templates/tiles/tileheadercontent.html',
        '<div class="bb-tile-header-content" ng-transclude></div>');
}]);
